/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Flex,
  Link,
  Option,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Switch,
  Text,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormInput,
  FormLabel,
  FormTextarea,
} from 'src/components/Common/FormComponent';
import {
  EnableDisableEnum,
  EnableDisableStatus,
  RecipientGroup,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import config from '../../config';
import {
  handleLinkClick,
  numberInputOnWheelPreventChange,
} from '@Utils/common';

export const InlineError = (props: any) => (
  <Text fontSize="sm" lineHeight="sm" color="red:50" {...props} />
);
// function isValidInteger(value: any, limit = 0): boolean {
//   const parsedValue = parseInt(value);
//   if (limit !== 0) {
//     return !isNaN(parsedValue) && parsedValue > 0 && parsedValue <= limit;
//   } else {
//     //no limit
//     return !isNaN(parsedValue) && parsedValue > 0;
//   }
// }
function NotifyAdmin(props: {
  status: EnableDisableStatus;
  toAccount: string;
  subject: string;
  message: string;
  notifySettingType: number;
  intervalNum: number;
  intervalType: number;
  occurenceNum: number;
  recipientGroupId: number;
  recipientGroupEnabled: EnableDisableStatus;
  recipientGroups: RecipientGroup[];
  setStatus: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setToAccount: (toAccount: string) => void;
  setSubject: (subject: string) => void;
  setMessage: (message: string) => void;
  setNotifySettingType: (notifySettingType: number) => void;
  setIntervalNum: (intervalNum: number) => void;
  setIntervalType: (intervalType: number) => void;
  setOccurenceNum: (occurenceNum: number) => void;
  setRecipientGroupId: (recipientGroupId: number) => void;
  setRecipientGroupEnabled: (enabled: EnableDisableStatus) => void;
}) {
  const { t } = useTranslation();
  const {
    status,
    toAccount,
    subject,
    message,
    notifySettingType,
    intervalNum,
    intervalType,
    occurenceNum,
    recipientGroupId,
    recipientGroups,
    recipientGroupEnabled,
    setStatus,
    setToAccount,
    setSubject,
    setMessage,
    setNotifySettingType,
    setIntervalNum,
    setIntervalType,
    setOccurenceNum,
    setRecipientGroupId,
    setRecipientGroupEnabled,
  } = props;
  const [intervalNumError, setIntervalNumError] = React.useState('');
  useWhyDidYouUpdate('NotifyAdmin', {
    ...props,
    intervalNumError,
  });
  const receiverNumber = React.useMemo(() => {
    let receiverNumber = 0;
    let group;
    //for recipientGroupId 0, use default group
    if (recipientGroupId === 0) {
      group = recipientGroups.find((group: any) => group.isDefault === 1);
    } else {
      group = recipientGroups.find(
        (group: any) => group.id === recipientGroupId
      );
    }
    if (group) {
      setRecipientGroupId(group.id);
      receiverNumber = group.recipientNumber;
    }
    return receiverNumber;
  }, [recipientGroupId, recipientGroups]);
  const recipientGroupsDisplay = React.useMemo(() => {
    const groups = recipientGroups.map((group: RecipientGroup) => {
      let name = group.recipientGroupName;
      if (group.isDefault) {
        name = t(
          `globalSetting.recipientGroup.defaultGroup.policyNotification.name`
        );
      }
      return {
        ...group,
        recipientGroupName: name,
      };
    });
    return groups;
  }, [recipientGroups]);
  return (
    <Box>
      <Flex alignItems="center" mb="24px">
        <FormLabel
          label={t('policy.label.notifyAdmin')}
          width="160px"
          withColon
        />
        <Switch
          checked={!!status}
          value={status}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('ntfEnableNotifyAdmin');
            setStatus(e);
          }}
        />
        <Text ml="2x">
          {status ? t('common.label.on') : t('common.label.off')}
        </Text>
      </Flex>
      <Flex alignItems="start" mb="16px">
        <FormLabel label={t('policy.label.to')} width="160px" withColon />
        <Flex direction="column">
          <Flex mb="16px">
            <RadioGroup
              value={recipientGroupEnabled}
              onChange={(value: number) => {
                setRecipientGroupEnabled(Number(value));
              }}
              disabled={!status}
            >
              <Stack direction="row" spacing="3x">
                <Radio value={EnableDisableEnum.enabled}>
                  {t('policy.label.recipientGroup')}
                </Radio>
                <Radio value={EnableDisableEnum.disabled}>
                  {t('policy.label.customizedRecipients')}
                </Radio>
              </Stack>
            </RadioGroup>
          </Flex>
          <Flex mb="16px">
            {recipientGroupEnabled === 1 ? (
              <Flex direction="column">
                <Select
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    setRecipientGroupId(Number(e.target.value));
                  }}
                  width="362px"
                  value={recipientGroupId}
                  disabled={!status}
                >
                  {recipientGroupsDisplay.length ? (
                    recipientGroupsDisplay.map((group: any) => (
                      <Option value={group.id} key={group.id}>
                        {group.recipientGroupName}
                      </Option>
                    ))
                  ) : (
                    <Option value={0}>No recipient group</Option>
                  )}
                </Select>
                <Text whiteSpace="pre-wrap" mt={6}>
                  {t('policy.label.recipient', {
                    RECEIVERNUMBER: receiverNumber,
                  })}
                  <Link
                    onClick={handleLinkClick}
                    href={`policy/global-settings/notification-settings`}
                    target="_blank"
                  >
                    {t('policy.label.viewRecipient')}
                  </Link>
                </Text>
              </Flex>
            ) : (
              <FormInput
                placeholder={t('policy.placeholder.accountType')}
                value={toAccount}
                maxLength={255}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log(e.target.value);
                  setToAccount(e.target.value);
                }}
                disabled={!status}
                width="701px"
                required
              />
            )}
          </Flex>
        </Flex>
      </Flex>
      <Flex mb="24px">
        <FormLabel label={t('policy.label.subject')} width="160px" withColon />
        <FormInput
          placeholder={t('policy.label.subjectDesc')}
          width="701px"
          value={subject}
          disabled={!status}
          maxLength={200}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSubject(e.target.value);
          }}
        />
      </Flex>
      <Flex mb="24px">
        <FormLabel label={t('policy.label.message')} width="160px" withColon />
        <FormTextarea
          placeholder={t('policy.label.messageDesc')}
          width="701px"
          height="137px"
          value={message}
          disabled={!status}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            setMessage(e.target.value);
          }}
        />
      </Flex>
      <Flex alignItems="start">
        <FormLabel
          label={t('policy.label.notificationThreshold.title')}
          width="160px"
          withColon
        />
        <Flex direction="column">
          <RadioGroup
            width="362px"
            value={notifySettingType}
            disabled={!status}
            onChange={(value: number) => {
              console.log(value);
              setNotifySettingType(Number(value));
            }}
          >
            <Stack spacing="6x">
              <Flex>
                <Radio value={0} mr="24px">
                  {t('policy.label.notificationThreshold.periodically')}:
                </Radio>
                <FormInput
                  value={intervalNum + ''}
                  width="70px"
                  mr="2x"
                  type="number"
                  error={!!intervalNumError}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    console.log(e.target.value);
                    //enable delete to 0
                    //if on blur the value still zero, set it to 1
                    if (e.target.value === '') {
                      setIntervalNum(0);
                      return;
                    }
                    const num = parseInt(e.target.value);
                    if (!isNaN(num)) {
                      setIntervalNum(Math.min(Math.max(num, 1), 99));
                    }
                  }}
                  disabled={!status}
                  onBlur={(e: any) => {
                    if (e.target.value === '0') {
                      setIntervalNum(1);
                    }
                  }}
                  onWheel={numberInputOnWheelPreventChange}
                />
                <Select
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    console.log(e.target.value, typeof e.target.value);
                    setIntervalType(parseInt(e.target.value));
                  }}
                  width="101px"
                  value={intervalType}
                  disabled={!status}
                >
                  <Option value={0}>
                    {t('policy.label.notificationThreshold.periodically.hours')}
                  </Option>
                  <Option value={1}>
                    {t('policy.label.notificationThreshold.periodically.days')}
                  </Option>
                </Select>
                {/* <InlineError message={intervalNumError} /> */}
              </Flex>
              <Flex>
                <Radio value={1} mr="24px">
                  {t('policy.label.notificationThreshold.byOccurrences')}:
                </Radio>
                <FormInput
                  value={occurenceNum + ''}
                  width="70px"
                  mr="2x"
                  type="number"
                  maxLength={3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.value === '') {
                      setOccurenceNum(0);
                      return;
                    }
                    const num = parseInt(e.target.value);
                    if (!isNaN(num)) {
                      setOccurenceNum(Math.min(Math.max(num, 1), 999));
                    }
                    // if (!isValidInteger(e.target.value, 999)) {
                    //   console.log('Please enter a positive integer');
                    // } else {
                    //   const num = parseInt(e.target.value);
                    //   setOccurenceNum(num);
                    // }
                  }}
                  disabled={!status}
                  onBlur={(e: any) => {
                    if (e.target.value === '0') {
                      setOccurenceNum(1);
                    }
                  }}
                  onWheel={numberInputOnWheelPreventChange}
                />
              </Flex>
              <Radio value={2}>
                {t('policy.label.notificationThreshold.individual')}
              </Radio>
            </Stack>
          </RadioGroup>
        </Flex>
      </Flex>
    </Box>
  );
}
export default NotifyAdmin;
